/* ==========================================================================
   Valino v3 (2026-11) — small storefront behaviours that pair with valino-v3.css.
   Loaded with defer at the end of layout/theme.liquid. Every block is
   independent and does nothing when its markup is absent.
   ========================================================================== */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* 1. Homepage rails: no product twice on one page.
     featured-collection renders the rail's cards plus up to 4 hidden spares
     (in-stock only). Walking the rails top to bottom, a product already shown
     in an earlier rail is swapped for the next spare. */
  function dedupeRails() {
    var rails = document.querySelectorAll('[data-vfc-rail]');
    if (!rails.length) return;
    var seen = {};
    /* The first gift-guide tab is on screen above the department rails: count its first
       four products as already shown so a rail below does not repeat them. */
    var guide = document.querySelector('.vgg__panel:not([hidden])');
    if (guide) {
      Array.prototype.slice.call(guide.querySelectorAll('a.vgg__prod'), 0, 4).forEach(function (a) {
        var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (m) seen[m[1]] = true;
      });
    }
    Array.prototype.forEach.call(rails, function (rail) {
      var want = parseInt(rail.getAttribute('data-vfc-show'), 10) || 4;
      var shown = 0;
      var items = rail.querySelectorAll('[data-vfc-handle]');
      Array.prototype.forEach.call(items, function (li) {
        var handle = li.getAttribute('data-vfc-handle');
        if (shown < want && !seen[handle]) {
          li.removeAttribute('data-vfc-spare');
          seen[handle] = true;
          shown++;
        } else {
          li.setAttribute('data-vfc-spare', '');
        }
      });
      /* Never leave a rail short: if de-duplication removed too much, refill with the
         rail's own products (a repeat reads better than an empty slot). */
      if (shown < want) {
        Array.prototype.forEach.call(items, function (li) {
          if (shown < want && li.hasAttribute('data-vfc-spare')) {
            li.removeAttribute('data-vfc-spare');
            shown++;
          }
        });
      }
      var slider = rail.querySelector('slider-component');
      if (slider && typeof slider.initPages === 'function') {
        try { slider.initPages(); } catch (e) { /* slider re-measures on its own resize observer */ }
      }
    });
  }

  /* 2. Product page: ships-by line and sticky bar only while the selection can be bought. */
  function productPage() {
    var form = document.querySelector('product-form');
    if (!form || !document.querySelector('.product-form__submit')) return;
    document.body.classList.add('v3-pdp');
    function sync() {
      var btn = document.querySelector('.product-form__submit');
      var soldOut = !btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true' && !btn.classList.contains('loading');
      if (btn && btn.classList.contains('loading')) return;
      document.body.classList.toggle('v3-soldout', !!soldOut);
      var de = document.querySelector('[data-v2-de]');
      if (de) de.hidden = !!soldOut;
    }
    sync();
    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(form, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
    }
  }

  /* 3. Cart: the header cart icon opens the drawer, and its badge follows the cart. */
  function cartHeader() {
    var drawer = document.querySelector('cart-drawer');
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('[data-v3-cart-link]');
      if (!link || !drawer || typeof drawer.open !== 'function') return;
      if (window.location.pathname === '/cart') return;
      e.preventDefault();
      drawer.open(link);
    });

    function setBadge(count) {
      var link = document.querySelector('[data-v3-cart-link]');
      if (!link) return;
      var badge = link.querySelector('.vmn__badge');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'vmn__badge';
          link.appendChild(badge);
        }
        badge.textContent = count;
        badge.setAttribute('aria-label', count + ' items in cart');
      } else if (badge) {
        badge.remove();
      }
    }
    function refresh() {
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart) setBadge(cart.item_count); })
        .catch(function () { /* badge keeps its server-rendered count */ });
    }
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
      }
    } catch (e) { /* pubsub not on this page */ }
    document.addEventListener('cart:refresh', refresh);
  }

  /* 4. Mobile menu open → hide chat (CSS :has() covers modern browsers; this covers the rest). */
  function menuChat() {
    var dr = document.getElementById('vmn-dr');
    if (!dr || !('MutationObserver' in window)) return;
    function sync() { document.body.classList.toggle('v3-menu-open', dr.getAttribute('aria-hidden') === 'false'); }
    new MutationObserver(sync).observe(dr, { attributes: true, attributeFilter: ['aria-hidden'] });
    sync();
  }

  ready(function () {
    dedupeRails();
    productPage();
    cartHeader();
    menuChat();
  });
})();
